/**
 * Parses the opening and closing hours of a location and returns them in minutes from midnight.
 * @param {string} hours - The opening and closing hours in the format "HH:MMAM - HH:MMPM".
 * @returns {number[]} An array with two elements: open and close times in minutes from midnight.
 */
export const getOpenClose = (hours) => {
	return hours.split(' - ').map((time) => time.toUpperCase());
};
